import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetOrganizationDto } from 'woofwoof-api-public';
import { publicOrganizationApi } from 'src/api/organization-public';

export function useInvitationClinic(
  organizationId: string,
): UseQueryResult<GetOrganizationDto> {
  return useQuery({
    queryKey: ['invitation-clinic', organizationId],
    queryFn: async () =>
      (
        await publicOrganizationApi.organizationPublicControllerGetOrganizationById(
          { id: organizationId },
        )
      ).data,
    enabled: Boolean(organizationId),
    retry: false,
    staleTime: 60_000,
  });
}
